<template>
  <div>
    <errors :error-list="serverErrors"></errors>

    <h4 class="card-title mb-3">Claimable Tickets</h4>

    <!-- Filters -->
    <!-- <div class="row mb-3">
      <div class="col-sm-4">
        <div class="search-box mr-2 mb-2 d-inline-block">
          <div class="position-relative">
            <input v-model="searchQuery" type="text" class="form-control" placeholder="Search..."/>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-sm-8 text-right">
        <sort-by-filters :filters="filters"></sort-by-filters>
      </div>
    </div> -->
    <!-- / Filters -->

    <div class="card" v-if="isLoading||searchQueryIsDirty">
      <div class="card-body">
        <div class="text-center">
          <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
        </div>
      </div>
    </div>

    <!-- Cards -->
    <div v-if="!(isLoading||searchQueryIsDirty)" class="card-results-wrapper">
      <ticket-card v-for="ticket in ticketResults" :key="ticket.id" :ticket="ticket"></ticket-card>
      <div class="card" v-if="ticketResults.length === 0">
        <div class="card-body">
          <b class="text-danger">No results</b>
        </div>
      </div>
    </div>
    <!--- / Cards -->

    <pagination v-if="!(isLoading||searchQueryIsDirty) && tickets" :data="tickets" :limit="8"
                @pagination-change-page="loadTickets"></pagination>
  </div>
</template>

<script>
import Forms from "../../../../mixins/Forms";
import Tickets from "../../../../mixins/Tickets";
import SortByFilters from "../../tickets/index/SortByFilters";

let _ = require('lodash');
import axios from 'axios';
import Dates from "../../../../mixins/Dates";
import TicketCard from "../../../../components/tickets/TicketCard";

export default {
  name: "MyTickets",
  mixins: [Forms, Tickets, Dates],
  components: {TicketCard, SortByFilters},
  data() {
    return {
      serverErrors: [],
      isLoading: false,
      tickets: null,

      searchQueryIsDirty: false,
      searchQuery: '',
      filters: {
        sort_by: 'created_at',
        sort_order: 'DESC',
        results_per_page: 10,
        only_show_my_tickets: true
      }
    }
  },

  computed: {
    ticketResults() {
      if (this.tickets) {
        return this.tickets.data;
      }
      return [];
    }
  },

  methods: {
    determineSearchParams(page) {
      return {
        q: this.searchQuery,
        page: page,
        results_per_page: this.filters.results_per_page,
        sort_by: this.filters.sort_by,
        sort_order: this.filters.sort_order,
        only_show_my_tickets: this.filters.only_show_my_tickets,
        not_closed: true
      };
    },

    loadTickets: _.debounce(function (page = 1) {
      let vm = this;
      vm.serverErrors = [];
      vm.isLoading = true;
      axios.post(API_BASE + '/tickets/search-claimable', vm.determineSearchParams(page)).then(r => {
        vm.tickets = r.data;
        vm.isLoading = false;
        vm.searchQueryIsDirty = false;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    }),

    setup() {
      this.loadTickets();
    }
  },

  watch: {
    '$route': 'setup',
    searchQuery: function () {
      this.searchQueryIsDirty = true;
      this.loadTickets();
    },
    filters: {
      handler: function () {
        this.loadTickets();
      },
      deep: true
    }
  },

  created() {
    this.setup();
  }
}
</script>

<style scoped>

</style>
